module.exports = __webpack_public_path__ + "static/media/options.2e12b4a9.png";